import { jsx } from 'react/jsx-runtime';
import { usePolarisVizContext } from '../../hooks/usePolarisVizContext.js';

function LinearGradientWithStops({
  gradient,
  id,
  x1 = '0%',
  x2 = '0%',
  y1 = '100%',
  y2 = '0%',
  gradientUnits = 'objectBoundingBox'
}) {
  const {
    components: {
      LinearGradient,
      Stop
    }
  } = usePolarisVizContext();
  return /*#__PURE__*/jsx(LinearGradient, {
    id: id,
    x1: x1,
    x2: x2,
    y1: y1,
    y2: y2,
    gradientUnits: gradientUnits,
    children: gradient.map(({
      color,
      offset,
      stopOpacity = 1
    }) => /*#__PURE__*/jsx(Stop, {
      offset: `${offset}%`,
      stopColor: color,
      stopOpacity: stopOpacity
    }, `${id}-${color}-${offset}`))
  });
}

export { LinearGradientWithStops };
